const t = {
  name: "Checkmark",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.99996 19.4144L22.4142 6.00015L21 4.58594L8.99981 16.5861L2.99966 10.5859L1.58545 12.0002L8.99996 19.4144Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Checkmark
};
